export const errorTexts = {
    required: 'pole jest wymagane',
    Email: 'e-mail nie jest prawidłowy',
    PhoneNumber: 'numer telefonu nie jest prawidłowy',
    TaxNumber: 'nip nieprawidłowy',
    minFloat: 'liczba jest zbyt mała',
    maxFloat: 'liczba jest zbyt duża',
}